module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (_vm.icon) ? _c('div', {
    staticClass: "l-level"
  }, [_c('div', {
    staticClass: "l-level__left",
    class: _vm.color
  }, [_c('i', {
    staticClass: "icon-3x icon",
    class: _vm.icon
  })]), _vm._v(" "), _c('div', {
    staticClass: "l-level__right"
  }, [_c('div', {
    staticClass: "l-level__item c-count u-textRight"
  }, [_c('div', {
    staticClass: "c-count__label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (typeof _vm.value === 'object') ? _c('div', {
    staticClass: "c-count__content",
    style: (_vm.style)
  }, _vm._l((_vm.value), function(val) {
    return _c('div', [_vm._v("\n            " + _vm._s(val) + "\n          ")])
  }), 0) : _c('div', {
    staticClass: "c-count__content",
    style: (_vm.style)
  }, [_vm._v("\n          " + _vm._s(_vm.value) + "\n        ")])])])]) : _c('div', {
    staticClass: "c-panel__body"
  }, [_c('div', {
    staticClass: "l-level"
  }, [_c('div', {
    staticClass: "l-level__item c-count"
  }, [_c('div', {
    staticClass: "c-count__label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (typeof _vm.value === 'object') ? _c('div', {
    staticClass: "c-count__content",
    style: (_vm.style)
  }, _vm._l((_vm.value), function(val) {
    return _c('div', [_vm._v("\n            " + _vm._s(val) + "\n          ")])
  }), 0) : _c('div', {
    staticClass: "c-count__content",
    style: (_vm.style)
  }, [_vm._v("\n          " + _vm._s(_vm.value) + "\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c50836f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/BoxInfo.vue
// module id = 3426
// module chunks = 0